import React from "react";
import { createRoot } from "react-dom/client";
import { PublicHome, InfoPage, AdvocateDirectory, MaheshProfile } from "../../../components/public-site";
import { Workspace } from "../../../components/workspace";
import { ProductionSignIn } from "./production-sign-in";
import "../../../app/globals.css";
import "../../../app/premium.css";
import "../../../app/workspace.css";

const path = window.location.pathname.replace(/\/$/, "") || "/";
let page: React.ReactNode;
if (path === "/") page = <PublicHome />;
else if (["/platform", "/security", "/plans", "/how-it-works", "/about"].includes(path)) page = <InfoPage page={path.slice(1)} />;
else if (path === "/advocates") page = <AdvocateDirectory />;
else if (path === "/advocates/mahesh-jagtap") page = <MaheshProfile />;
else if (path === "/sign-in") page = <ProductionSignIn />;
else if (path === "/chamber") page = <Workspace />;
else if (path === "/office") page = <Workspace office />;
else page = <InfoPage page="about" />;

createRoot(document.getElementById("root")!).render(<React.StrictMode>{page}</React.StrictMode>);
